import { Center } from '@mantine/core';
import { getWeightIndicatorColor } from 'utils/measurements/weight';
import { calculateBmiIndicator, displayMeasurementWeightUnitsLabel } from 'utils/helpers';
import { WeightMeasurement } from 'models/weight';
import { UnitType } from 'models/generic';
import classes from './CalendarBadge.module.css';

interface WeightCalendarBadgeProps {
  fullItem: WeightMeasurement;
  onClick: (id: WeightMeasurement) => void;
  unitSystem: UnitType;
}

export const WeightCalendarBadge = ({ fullItem, onClick, unitSystem }: WeightCalendarBadgeProps) => {
  const { data: itemData } = fullItem;
  if (!itemData) return null;

  return (
    <Center
      className={`${classes.calendarBadge}`}
      bg={getWeightIndicatorColor(calculateBmiIndicator(itemData.value))}
      w={95}
      h={30}
      onClick={() => onClick(fullItem)}
    >
      {!itemData?.value || !itemData.input.weight
        ? '-'
        : `${displayMeasurementWeightUnitsLabel({ weight: itemData.input.weight, unitSystem })} | ${itemData.value?.toFixed(1)}`}
    </Center>
  );
};
